import { isDriveVideoFile } from "./driveFolder";

export type ImageNoticeHeroMedia = {
  url: string;
  isVideo: boolean;
};

type UploadedHeroFile = {
  fileUrl: string;
  fileName: string;
  contentType: string;
};

const isHeroMediaFile = (file: UploadedHeroFile) =>
  Boolean(
    file.contentType?.startsWith("image/") ||
      isDriveVideoFile(file.contentType, file.fileName)
  );

/**
 * Hero URL for native-style image notice review (first image or video upload).
 */
export function resolveImageNoticeHeroMedia(
  uploadedFiles?: UploadedHeroFile[],
  attachmentUrl?: string,
  imageUrl?: string
): ImageNoticeHeroMedia | null {
  const files = uploadedFiles || [];
  const fromUpload =
    files.find(isHeroMediaFile) ??
    (files.length === 1 ? files[0] : undefined);

  if (fromUpload?.fileUrl) {
    return {
      url: fromUpload.fileUrl,
      isVideo: isDriveVideoFile(fromUpload.contentType, fromUpload.fileName),
    };
  }

  const att = attachmentUrl?.trim();
  if (att) {
    return {
      url: att,
      isVideo: isDriveVideoFile(undefined, att),
    };
  }

  const img = imageUrl?.trim();
  if (img) {
    return {
      url: img,
      isVideo: isDriveVideoFile(undefined, img),
    };
  }

  return null;
}
